import { getAccessToken } from "../utils/browserStorage";

import { toast } from "react-toastify";
/**
 * @typedef RequestBody
 * @type {object}
 * @property {string} method - Request method [GET|POST|PUT|DELETE]
 * @property {string} mode - CORS enabled
 * @property {object} headers - Request headers
 * @property {string} body - Stringified JSON payload
 *
 */

export class Base {
  constructor() {
    if (this.constructor === Base) {
      throw new Error("Cannot instantiate Abstract class Base");
    }
    let host = window.location.origin;

    this.apiBaseURL = process.env.REACT_APP_API_URL || `${host}/api`;
  }

  /**
   * @protected
   *
   * @param {string} route
   * @returns {string} Full API endpoint
   */
  _getFullURL(route) {
    return this.apiBaseURL + route;
  }

  /**
   * @protected
   *
   * @description Generates a request body for making API requests
   * @param {Object} myObj
   * @param {boolean} myObj.authentication
   * @param {?object} myObj.payload
   * @param {string} [myObj.method=GET]
   * @param {string} [myObj.mode=cors]
   * @returns {RequestBody} Request body
   */
  _generateRequestBody({
    authentication = true,
    publicAuthentication = false,
    payload,
    method = "GET",
    mode = "cors",
  }) {
    const reqBody = {
      mode,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    reqBody["method"] = method;

    if (authentication) {
      reqBody["headers"]["Authorization"] = `Bearer ${getAccessToken()}`;
    }
    if (publicAuthentication) {
      reqBody["headers"]["Authorization"] = `D2jFQpFeuJVhud5BWEPfSCdME`;
    }


    if (payload && payload instanceof Object) {
      reqBody["body"] = JSON.stringify(payload);
    }

    return reqBody;
  }

  _secureFetch(url, method, payload) {
    return new Promise((resolve, reject) => {
      fetch(
        url,
        this._generateRequestBody({
          authentication: true,
          payload,
          method,
        })
      )
        .then((response) => {
          // response only can be ok in range of 2XX
          if (response.ok) {
            // you can call response.json() here too if you want to return json
            resolve(response);
          } else {
            //handle errors in the way you want to
            if (response.status === 403) {
              toast.error("Your Session Expired Please Login Again");
              localStorage.removeItem("ACCESS_TOKEN");

              setTimeout(() => {
                window.location.href = "/login";
              }, 1000);
            }
            //here you also can thorow custom error too
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  list(obj) {
    throw new Error("Abstract Method has no implementation");
  }

  create(payload) {
    throw new Error("Abstract Method has no implementation");
  }

  get(id) {
    throw new Error("Abstract Method has no implementation");
  }

  update(id, payload) {
    throw new Error("Abstract Method has no implementation");
  }

  delete(id) {
    throw new Error("Abstract Method has no implementation");
  }
}
